import * as React from 'react';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

export default function ToastMessage(props) {
    const Alert = React.forwardRef(function Alert(props, ref) { return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />; });
    const { open, onClose, severity, message } = props;
    const getColor=(severity, theme)=>{
        return theme.palette.white.main;     
    } 

    return (
        <Stack spacing={2} sx={{ width: '100%' }}>
            <Snackbar id={props?.id} open={open} autoHideDuration={5000} onClose={onClose} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} >
                <Alert  onClose={onClose} severity={severity} sx={{color:(theme)=>getColor(severity,theme), width: '100%' }}>{message}</Alert>
            </Snackbar>
        </Stack>
    );
}
